





































































// tslint:disable-next-line
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { SwToggle } from '@libs-uuif/shared/sw-toggle';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { CreateElement, VNode } from 'vue';
import { SwTable, TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { v4 as uuidv4 } from 'uuid';

const cssPrefix3 = 'product-binding';
const storeName = 'ConnectWiseManageStoreModule';

@Component({
  components: {
    SwSelect,
    SwToggle,
    SwIconButton,
    SwTable,
  },
})
export default class CustomCatalogMapping extends SwExtendedVue {
  cssPrefix3 = cssPrefix3;

  isDefaultBinding: boolean = true;
  snwlProductList: SelectOption[] = [];
  cwProductList: SelectOption[] = [];
  selectedSnwlProd:any = '';
  selectedCwProd:any = '';
  selectedSnwlProdObj: any = {}; // For storing both id and value when slected from snwlProdSelect
  selectedCwProdObj: any = {}; // For storing both id and value when slected from cwProdSelect
  customCatalogMappingData: TableEntry[] = [];
  snwlRawProductData:any = [];

  get catalogMappingColumnConfig(): TableColumnConfig[] {
    return [
      {
        key: 'mswCatalog',
        dataKey: 'mswCatalog',
        title: 'SonicWall Product',
        width: 280,
      }, {
        key: 'cwCatalog',
        dataKey: 'cwCatalog',
        title: 'ConnectWise Product',
        width: 280,
      },
      {
        key: 'action',
        dataKey: '',
        title: '',
        // tslint:disable-next-line
        render: (h: CreateElement, data: any): VNode => {
          // let menu: boolean = false;
          return (
            <div>
              <SwIconButton
                icon="close"
                color="red"
                nativeOn-click={() => {
                  this.onRemoveCatalogMapping(data);
                }}
              />
            </div>
          ) as VNode;
        },
        width: 40,
      },
    ];
  }

  get showCustomCatalogMapping() {
    return this.$store.getters[`${storeName}/getShowCustomCatalogMapping`];
  }

  async fetchProductCatalogs() {
    this.$store
    .dispatch(`${storeName}/getProductCatalogs`)
    .then((resp:any) => {
      if (resp.operationStatus === 'OK' && resp?.content) {
        const respContent:any = resp?.content || {};
        if (respContent?.available_products && (respContent?.available_products?.length > 0)) {
          this.snwlRawProductData = respContent?.available_products;
          respContent?.available_products?.forEach((product:any) => {
            this.snwlProductList.push({
              id: product?.msw_catalog_id?.toString(),
              label: product?.msw_product_name,
              value: product?.msw_catalog_id?.toString(),
            });
          });
        }
        if (respContent?.available_catalogs && (respContent?.available_catalogs?.length > 0)) {
          respContent?.available_catalogs?.forEach((product:any) => {
            this.cwProductList.push({
              id: product?.catalog_id?.toString(),
              label: product?.catalog_name,
              value: product?.catalog_id?.toString(),
            });
          });
        }
        if (respContent?.existing_custom_mappings) {
          if (respContent?.existing_custom_mappings?.length === 0) {
            this.isDefaultBinding = true;
            this.$store.commit(`${storeName}/updateIsCustomCatalogStepValidated`, false);
          } else {
            this.isDefaultBinding = false;
            respContent?.existing_custom_mappings?.forEach((maapings:any) => {
              const snwlProd:any = this.snwlProductList.filter((prods:any) => prods.value === maapings.msw_catalog_id)[0] || {};
              const cwCatalog:any = this.cwProductList.filter((prods:any) => prods.value === maapings.cw_catalog_id)[0] || {};
              this.customCatalogMappingData.push({
                _key: `${uuidv4()}`,
                mswCatalog: snwlProd.label,
                cwCatalog: cwCatalog.label,
                mswCatalogId: snwlProd.value,
                cwCatalogId: cwCatalog.value,
              });
              this.filterSnwlProdDropdownList(snwlProd.value);
            });
          }
        }
      } else {
        this.renderErrorMessage(resp?.msgDesc);
      }
    })
    .catch((error:any) => {
      console.error(error);
      if (error.response) {
        this.renderErrorMessage(error.response.data.message);
      } else {
        this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
        .toString());
      }
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  onAddMappingButton() {
    this.customCatalogMappingData.push({
      _key: `${uuidv4()}`,
      mswCatalog: this.selectedSnwlProdObj.label,
      cwCatalog: this.selectedCwProdObj.label,
      mswCatalogId: this.selectedSnwlProdObj.value,
      cwCatalogId: this.selectedCwProdObj.value,
    });
    this.filterSnwlProdDropdownList(this.selectedSnwlProdObj.value);
    this.selectedSnwlProdObj = {};
    this.selectedCwProdObj = {};
    this.selectedSnwlProd = '';
    this.selectedCwProd = '';
    this.$store.commit(`${storeName}/updateCwProductBindings`, this.customCatalogMappingData);
    if (this.customCatalogMappingData.length !== 0 && !this.isDefaultBinding) {
      this.$store.commit(`${storeName}/updateIsCustomCatalogStepValidated`, false);
    }
  }

  onSnwlProdSelect(prodId:string) {
    this.selectedSnwlProdObj = this.snwlProductList.filter((prods:any) => prods.value === prodId)[0] || {};
  }

  onCwProdSelect(prodId:string) {
    this.selectedCwProdObj = this.cwProductList.filter((prods:any) => prods.value === prodId)[0] || {};
  }

  onRemoveCatalogMapping(data:any) {
    console.warn('remove clicked');
    this.customCatalogMappingData = this.customCatalogMappingData.filter((prods:any) => {
      if (prods.mswCatalogId !== data.entry.mswCatalogId) {
        return prods;
      }
    });
    this.snwlProductList.push({
      id: data.entry.mswCatalogId,
      label: data.entry.mswCatalog,
      value: data.entry.mswCatalogId,
    });
    this.$store.commit(`${storeName}/updateCwProductBindings`, this.customCatalogMappingData);
    if (this.customCatalogMappingData.length === 0 && !this.isDefaultBinding) {
      this.$store.commit(`${storeName}/updateIsCustomCatalogStepValidated`, true);
    }
  }

  filterSnwlProdDropdownList(filterValue:any) {
    this.snwlProductList = this.snwlProductList.filter((prods:any) => {
      if (prods.value !== filterValue) {
        return prods;
      }
    });
  }

  onDefaultBindingChange() {
    if (this.isDefaultBinding) {
      this.$store.commit(`${storeName}/updateIsCustomCatalogStepValidated`, false);
      if (this.customCatalogMappingData.length > 0) {
        confirmService.confirm({
          status: 'major',
          message: 'The custom catalog mappings selected will be reset to the default catalog mapping. Do you wish to continue?',
          buttons: [
            {
              key: 'cancel',
              name: this.$t('common.cancel')
              .toString(),
            },
            {
              key: 'ok',
              name: this.$t('common.confirm')
              .toString(),
              isDefault: true,
            },
          ],
        })
        .then((isConfirmed: any) => {
          if (isConfirmed === 'ok') {
            this.customCatalogMappingData = [];
            this.$store.commit(`${storeName}/updateCwProductBindings`, this.customCatalogMappingData);
          }
          if (isConfirmed === 'cancel') {
            this.isDefaultBinding = false;
          }
        });
      }
    } else {
      if (this.customCatalogMappingData.length === 0) {
        this.$store.commit(`${storeName}/updateIsCustomCatalogStepValidated`, true);
      }
    }
  }

  exportExcel() {
    console.warn('inside export excel for catalogs');
    const excelList: any = [];
    let column:any[] = [];
    column.push('PRODUCT NAME');
    column.push('DEFAULT CATALOG NAME');
    excelList.push(column);
    column = [];
    for (const headers of this.snwlRawProductData) {
      column.push(headers.msw_product_name);
      column.push(headers.short_identifier);
      excelList.push(column);
      column = [];
    }
    const csvContent = ''.concat(excelList.map((e:any) => e.join(','))
    .join('\n'));
    const blob = new Blob([(csvContent)]);
    const link:any = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'DefaultProductCatalog.xls');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
  }

  // tslint:disable-next-line
  renderErrorMessage(message: string, color: boolean = false) {
    this.$emit('handleErrMsg', { message, color });
  }

  async mounted() {
    this.$store.commit(`${storeName}/updateIsCustomCatalogStepValidated`, false);
    await this.fetchProductCatalogs();
  }

}
